import { render } from "./appAndroidBanner.vue?vue&type=template&id=48a8240a&scoped=true"
import script from "./appAndroidBanner.vue?vue&type=script&lang=js"
export * from "./appAndroidBanner.vue?vue&type=script&lang=js"

import "./appAndroidBanner.vue?vue&type=style&index=0&id=48a8240a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a8240a"]])

export default __exports__